'use client';

import Link from 'next/link';
import { useSearchParams } from 'next/navigation';

import { Button } from '@kit/ui/button';
import { Trans } from '@kit/ui/trans';

import { saveLocationOff } from '../_lib/location-preference';

/**
 * Empty-state "Clear filters" CTA (BAL-500). A bare `<Link href="/marketplace">`
 * looks correct but isn't: when a location filter is active, dropping the
 * `near`/`radius`/`city` params from the URL is not enough —
 * `MarketplaceLocationInit` re-applies the localStorage preference on the very
 * next paint, bouncing the buyer straight back to the same empty grid. The
 * chip × and `clearAll()` in `active-filters.tsx` already call
 * `saveLocationOff()` first; this is the one clear-filters path that didn't.
 */
export function ClearFiltersButton() {
  const searchParams = useSearchParams();
  const hasLocation = Boolean(searchParams.get('near'));

  return (
    <Button
      asChild
      variant="outline"
      onClick={hasLocation ? () => saveLocationOff() : undefined}
    >
      <Link href="/marketplace">
        <Trans i18nKey="common:clearFilters" />
      </Link>
    </Button>
  );
}
